var map = {
	"./iconAbtasttheorem.jpg": 124,
	"./iconAudacity.jpg": 997,
	"./iconDFT.jpg": 733,
	"./iconErwartungswert_Varianz.jpg": 97,
	"./iconFaltung.jpg": 42,
	"./iconGezinkteWuerfel.jpg": 296,
	"./iconGoogleColab.jpg": 23,
	"./iconKorrelationskoeffizient.jpg": 276,
	"./iconLeakage.jpg": 517,
	"./iconLinksammlung.jpg": 957,
	"./iconMittelwert.jpg": 796,
	"./iconPlatzhalter.jpg": 240,
	"./iconSin.jpg": 281,
	"./iconStichprobe.jpg": 12,
	"./iconTierstimmen.jpg": 230,
	"./iconVerteilungen.jpg": 249,
	"./iconWolframAlpha.jpg": 960
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 180;